import type {RouteRecordRaw} from "vue-router";

export const routeName = 'EditDocument';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'edit/:id(\\d+)',
    component: () => import('@/pages/EditDocument'),
    props: route => ({ id: Number(route.params.id) }),
    meta: {
        isHide: true,
    }
};